import styled, { css } from 'styled-components'

export interface StyledProps {
  width?: string | number
  fullWidth?: boolean
  variant?: 'primary' | 'secondary' | 'line'
  marginTop?: string
  marginBottom?: string
}
export const ButtonStyled = styled.button<StyledProps>`
  ${(props) => {
    let variant = props.theme.button.primary
    if (props.variant === 'secondary') {
      variant = props.theme.button.secondary
    }
    if (props.variant === 'line') {
      variant = props.theme.button.line
    }

    return css`
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-top: ${props.marginTop};
      margin-bottom: ${props.marginBottom};
      padding: 0 16px;
      box-sizing: border-box;
      border: 1px solid;
      background: ${variant.backgroundColour};
      color: ${variant.colour};
      border-radius: ${props.theme.button.borderRadius};
      font-size: 16px;
      font-family: ${props.theme.button.fontFamily};
      font-weight: ${props.theme.button.fontWeight};
      text-transform: ${props.theme.button.textTransform};
      text-align: ${props.theme.button.textAlign};
      box-shadow: none;
      border-color: ${variant.borderColour};
      outline-color: ${variant.outlineColour};
      outline-offset: 2px;
      outline-width: 2px;
      cursor: pointer;
      min-height: 50px;
      box-shadow: 0px 9px 15px 0px ${variant.boxShadowColour};
      transition: box-shadow 400ms ease-in-out;

      width: ${props.fullWidth ? '100%' : props.width || 'auto'};

      :disabled,
      a&:not([href]) {
        background-color: ${variant.disabledBackground};
        color: ${variant.disabledColour};
        cursor: not-allowed;
      }

      @media (min-width: 768px) {
        min-height: 60px;
        font-size: 18px;
      }

      :hover:not(:disabled):not(a),
      a&[href]:hover,
      :where(.hover):not(:disabled) {
        box-shadow: 0px 23px 18.8px 0px ${variant.hoverBoxShadowColour};
        border-color: ${variant.hoverBorderColour};
      }
      :active:not(:disabled):not(a),
      a&[href]:active,
      :where(.active):not(:disabled) {
        background-color: ${variant.activeBackgroundColour};
      }
      :focus,
      :where(.focus):not(:disabled) {
        outline-style: solid;
      }
      :active:focus,
      :where(.focus.active):not(:disabled) {
        outline-style: solid;
      }
    `
  }}
`
